<!--
* @Name：跨组织调拨审批页面
* @Author: 王超
* @Date: 2022-03-09
-->
<template>
  <div class="approval-container">
    <van-nav-bar title="跨组织调拨审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">跨组织调拨审批单</span>
        </template>
        <base-info :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="attachment">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">附件信息</span>
        </template>
        <hi-attachment :attach-list="attachList"></hi-attachment>
      </van-collapse-item>
      <van-collapse-item name="materialDetails">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">调拨物料明细</span>
        </template>
        <material-details />
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { coopCotCreateHead } from '@/api/cotRequest'
import Bridge from '@/components/dsbridge'
export default {
  name: 'CotApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'material-details': () => import('./components/MaterialDetails.vue')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'approvalOpinions'],
      // 主单信息对象
      headInfo: {},
      // 附件列表
      attachList: [],
      // 审批单ID
      // cotCreateHeadId: this.$store.getters.businessKey
      cotCreateHeadId: this.$route.query.businessKey
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    // 调用接口获取主单基本数据和附件信息
    async initData() {
      const headResp = await coopCotCreateHead(this.cotCreateHeadId)
      this.headInfo = headResp.data
      this.attachList = this.headInfo.uploadFile
    },
    // 返回到审批列表页
    onClickLeft() {
      // this.$router.push('/todo')
      Bridge.callMethodSyn('app.jsLeavePage', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
